'use client'

import Link from 'next/link'
import { track } from '@/lib/tracking'

/**
 * Link that fires a GTM event on click. Lets server components (edition,
 * storyline, archive pages) emit events without becoming client components
 * themselves. `external` renders a new-tab <a> instead of a next/link.
 */
export default function TrackedLink({
  event,
  params,
  href,
  external = false,
  children,
  ...props
}) {
  const handleClick = () => {
    if (event) track(event, params)
  }

  if (external) {
    return (
      <a
        href={href}
        onClick={handleClick}
        target="_blank"
        rel="noopener noreferrer"
        {...props}
      >
        {children}
      </a>
    )
  }

  return (
    <Link href={href} onClick={handleClick} {...props}>
      {children}
    </Link>
  )
}
